import type React from 'react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectUserData } from '@/domains/Auth/features/authSlice';
import type { Context, UserData } from '@/types';
import { AppContext } from './context';

interface AppContextProviderProps {
  children: React.ReactNode;
}

export const AppContextProvider: React.FC<AppContextProviderProps> = ({ children }) => {
  const userData: UserData = useSelector(selectUserData);

  const memoizedValue: Context = useMemo(
    () => ({
      userId: userData?.user?.id,
      userPermissions: userData?.permissions ?? [],
      userRoles: userData?.roles ?? [],
    }),
    [userData],
  );

  return <AppContext.Provider value={memoizedValue}>{children}</AppContext.Provider>;
};
